import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { doRequest } from '@r1-frontend/do-request/index';
import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites/dto/ResponseDto';
import { getTopCities } from '@r1-frontend/api-domru/api-content/v1/geography/get-top-cities';
import { setTopCities } from '@r1-frontend/entities/Layout/CitySelectContainer/store/actionCreators';
import { TState } from '@r1-frontend/entities/Layout/CitySelectContainer/store/reducer';
import selectProviderId from '@r1-frontend/entities/stores/city/selectors/selectProviderId';

const fetchTopCities = () => {
    return async(dispatch: ThunkDispatch<TState, void, AnyAction>, getState: () => TState): Promise<void> => {
        const state = getState();
        const providerId = selectProviderId(state);

        const resp = await doRequest.apiContent<ICitySatellite[]>(
            getTopCities(providerId),
        );

        if (resp.isSuccess) {
            dispatch(setTopCities(resp.payload));
        }
    };
};

export default fetchTopCities;
